import { Download, Loader2 } from 'lucide-react';
import { useState } from 'react';
import { fetchAccountUsageData } from '../../services/admin-api';
import { downloadAccountUsageCsv } from './account-usage-csv';

interface AccountUsageExportButtonProps {
  /** エクスポート対象の月（YYYY-MM） */
  month: string;
}

/**
 * 選択中の月のアカウント別利用額を CSV でダウンロードするボタン
 *
 * モデルの絞り込みは反映しない（常に全モデルの合計）。部門別の集計に使うため、
 * 画面の絞り込み次第で合計が変わると突き合わせを誤る
 */
export function AccountUsageExportButton({ month }: AccountUsageExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleExport = async () => {
    setIsExporting(true);
    setError(null);
    try {
      const data = await fetchAccountUsageData(month);
      downloadAccountUsageCsv(data);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'エクスポートに失敗しました');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex flex-col items-end">
      <button
        type="button"
        onClick={handleExport}
        disabled={isExporting}
        title="選択中の月のアカウント別利用額（全モデル合計）を CSV でダウンロード"
        className="flex items-center gap-2 px-3 py-2 bg-muted border border-border rounded-lg text-foreground text-sm hover:bg-muted/70 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isExporting ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Download className="w-4 h-4" />
        )}
        CSVエクスポート
      </button>
      {error && (
        <p role="alert" className="text-red-400 text-xs mt-1">
          エクスポートに失敗しました: {error}
        </p>
      )}
    </div>
  );
}
